import { MapPin, Phone, Mail } from "lucide-react";
import PublicNav from "../../components/layout/PublicNav";
import Footer, { CONTACT } from "../../components/layout/Footer";
import QuickInquiryForm from "../../components/QuickInquiryForm";

const OFFICES = [
  {
    city: "Mumbai",
    label: "Head Office",
    address: "B 103-105, 1st Floor, Sagar Tech Plaza, Andheri Kurla Road, Saki Naka, Andheri (East), Mumbai – 400 072",
    phone: CONTACT.phone,
    fax: CONTACT.fax,
    departments: [
      { name: "Air Operations – Export", emails: ["shalaka@translogexpress.com", "maqsood@translogexpress.com", "praful@translogexpress.com", "mumawb@translogexpress.com"] },
      { name: "Air Operations – Import", emails: ["amit@translogexpress.com", "saloni@translogexpress.com", "siddhesh@translogexpress.com"] },
      { name: "Sea Operations",          emails: ["rehana@translogexpress.com", "csexports@translogexpress.com", "bl@translogexpress.com"] },
    ],
  },
  {
    city: "Ahmedabad", label: "Branch Office", address: "Ahmedabad, Gujarat",
    departments: [
      { name: "Air Operations – Export", emails: ["amdsales@translogexpress.com", "falguni@translogexpress.com"] },
      { name: "Air Operations – Import", emails: ["amdsales2@translogexpress.com", "arayna@translogexpress.com"] },
      { name: "Sea Operations",          emails: ["divyesh@translogexpress.com", "arayna@translogexpress.com"] },
    ],
  },
  {
    city: "Mundra", label: "Branch Office", address: "Mundra, Gujarat",
    departments: [
      { name: "Operations", emails: ["mundra@translogexpress.com"] },
    ],
  },
  {
    city: "Hyderabad", label: "Branch Office", address: "Hyderabad, Telangana",
    departments: [
      { name: "Air & Sea Operations", emails: ["hyd@translogexpress.com", "hydinfo@translogexpress.com", "hydsales@translogexpress.com"] },
    ],
  },
  {
    city: "Kolkata / Haldia", label: "Branch Office", address: "Kolkata / Haldia, West Bengal",
    departments: [
      { name: "Air & Sea Operations", emails: ["ccu@translogexpress.com", "kalyan@translogexpress.com", "ujjal@translogexpress.com"] },
    ],
  },
  {
    city: "Bangalore", label: "Branch Office", address: "Bangalore, Karnataka",
    departments: [
      { name: "Operations", emails: ["info@translogexpress.com", "blr@translogexpress.com"] },
    ],
  },
  {
    city: "Chennai", label: "Branch Office", address: "Chennai, Tamil Nadu",
    departments: [
      { name: "Air & Sea Operations", emails: ["info@translogexpress.com", "maa@translogexpress.com"] },
    ],
  },
  {
    city: "Delhi", label: "Branch Office", address: "Delhi, India",
    departments: [
      { name: "Air & Sea Operations", emails: ["info@translogexpress.com", "del@translogexpress.com"] },
    ],
  },
];

export default function ContactPage() {
  return (
    <div className="App">
      <PublicNav />

      {/* Hero */}
      <section style={{ background: "#DC2A1C" }} className="px-6 md:px-12 py-14 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-white/60 text-xs uppercase tracking-[0.2em] font-semibold mb-3">
            We're here to help
          </div>
          <h1 className="text-4xl sm:text-5xl font-black text-white tracking-tighter">
            Contact Us
          </h1>
          <p className="mt-3 text-white/80 text-sm max-w-lg leading-relaxed">
            Reach out to our team across India for freight quotes, enquiries, or support.
          </p>
        </div>
      </section>

      {/* Content + Sidebar */}
      <section className="bg-[#F8F9FA] py-16 px-6 md:px-12">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">

          {/* Left: office cards — 62% */}
          <div className="w-full lg:w-[62%] min-w-0">
            {/* Global contacts */}
            <div className="mb-8 bg-white rounded-2xl border border-gray-100 p-6 shadow-sm">
              <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#DC2A1C] mb-4">
                General Enquiries
              </div>
              <div className="grid sm:grid-cols-2 gap-4">
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-[#DC2A1C] flex-shrink-0" />
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.12em] text-gray-400 font-semibold mb-0.5">Phone</div>
                    <a href={`tel:${CONTACT.phoneHref}`} className="text-sm font-semibold text-[#DC2A1C] hover:underline">
                      {CONTACT.phone}
                    </a>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-[#DC2A1C] flex-shrink-0" />
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.12em] text-gray-400 font-semibold mb-0.5">Email</div>
                    <a href={`mailto:${CONTACT.email}`} className="text-sm font-semibold text-[#DC2A1C] hover:underline break-all">
                      {CONTACT.email}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Office grid */}
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-gray-400 mb-4">
              Our Offices
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              {OFFICES.map((o) => (
                <div
                  key={o.city}
                  className="bg-white rounded-xl border border-gray-100 p-5 shadow-sm hover:shadow-md transition-shadow"
                >
                  <div className="flex items-start gap-3">
                    <div
                      className="w-9 h-9 rounded-lg flex-shrink-0 grid place-items-center"
                      style={{ background: "rgba(220,42,28,0.08)" }}
                    >
                      <MapPin className="w-4 h-4" style={{ color: "#DC2A1C" }} />
                    </div>
                    <div className="min-w-0 w-full">
                      <div className="font-bold text-[#1A1A1A] text-sm">{o.city}</div>
                      <div
                        className="text-[10px] uppercase tracking-[0.12em] font-semibold mb-1"
                        style={{ color: o.label === "Head Office" ? "#DC2A1C" : "#9ca3af" }}
                      >
                        {o.label}
                      </div>
                      <p className="text-xs text-gray-500 leading-relaxed">{o.address}</p>
                      {o.phone && (
                        <a href={`tel:${o.phone.replace(/\s/g, "")}`} className="text-[11px] text-[#DC2A1C] hover:underline mt-1 block">
                          {o.phone}
                        </a>
                      )}
                      {o.fax && (
                        <p className="text-[11px] text-gray-400 mt-0.5">Fax: {o.fax}</p>
                      )}
                      {o.departments && (
                        <div className="mt-3 space-y-2">
                          {o.departments.map((dept) => (
                            <div key={dept.name}>
                              <div className="text-[10px] uppercase tracking-[0.1em] font-semibold mb-1" style={{ color: "#DC2A1C" }}>{dept.name}</div>
                              <div className="flex flex-col gap-0.5">
                                {dept.emails.map((email) => (
                                  <a key={email} href={`mailto:${email}`} className="text-[11px] text-gray-500 hover:text-[#DC2A1C] transition-colors break-all">
                                    {email}
                                  </a>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: form sidebar — 38% */}
          <div className="w-full lg:w-[38%] lg:sticky lg:top-6">
            <QuickInquiryForm compact={true} />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
